import gql from "graphql-tag";
import graphqlClient from "@/http/graphql/agile";

const UPDATE_USER_OPTION = `
	update_object_user_option(optionable_type: $optionable_type, optionable_id: $optionable_id, color: $color) {
		color
	}
`;

export default {
	init() {},
    
    updateUserOption(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation UpdateUserOption (
					$color: String!,
					$optionable_id: Int!,
					$optionable_type: String!
                ) {
                    ${UPDATE_USER_OPTION}
                }
				`,
				variables: {
					color: payload.color,
					optionable_id: payload.optionable_id,
					optionable_type: payload.optionable_type
				}
			})
			.then(response => response.data.update_object_user_option);
	}
};
